import { Product } from 'state/product'
import { Color } from 'state/color'
import { config } from 'state/product/config'

MK.events.on('product:calculateActiveProducts', (event = {}) => {
  // Display by Product ID or by SKU
  Product.active = (event.initialLoad ? Object.values(Product.index.ids) : Object.values(Product.index.ids).filter(product => product.is.active))

  // Determine whether we should display products & count by Product ID or by SKU/Color Variation.
  const displayBy = {
    color: (MK.page.renderByColor || Product.active.length <= config.thresholds.display.byID),
    id: (!MK.page.renderByColor && Product.active.length > config.thresholds.display.byID),
    sku: (MK.page.renderByColor || Product.active.length <= config.thresholds.display.byID),
  }

  Object.assign(Product.display.by, displayBy)
  Object.assign(Color.display.by, displayBy)
  console.log(Color.display, Product.display)

  if (Product.display.by.id) {
    // Update active product count
    Product.count = Product.active.length
  } else {
    Product.active = Object.values(Product.index.skus).filter(sku => sku.is.active)
    Product.count = Product.active.length
  }



  // Update active product count reflected in the DOM
  Product.nodes.count.setAttribute('data-items', `${Product.count}`)

  console.log(`DEBUG (product:calculateActiveProducts): Display by ID: ${Product.display.by.id}`)
})